import { DATE_MAX, DATE_MIN } from '@query/shared';
import { TextField } from '@mui/material';

export interface FieldDateProps {
  id: string;
  label: string;
  defaultValue: string;
  onChange: (value: string) => void;
}

/**
 * Поле даты — перенос FieldDateFC (FC.kt:48-71).
 *
 * Оригинал задавал границы и стиль через `asDynamic().inputProps` — в TSX это
 * штатный проп slotProps.htmlInput.
 */
export function FieldDate({ id, label, defaultValue, onChange }: FieldDateProps) {
  return (
    <TextField
      id={id}
      label={label}
      type="date"
      variant="standard"
      color="secondary"
      placeholder="DD.MM.YYYY"
      required
      defaultValue={defaultValue}
      className="cl3"
      slotProps={{
        htmlInput: {
          min: DATE_MIN,
          max: DATE_MAX,
          style: { background: '#b3ffb3', height: 15 },
        },
      }}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}
